import {
  MyRanking,
  RankedUser,
  UserCount,
  UserInformationType,
  UserPick,
} from "../services";

export const storeUserData = (data: UserInformationType) => {
  return localStorage.setItem("myData", JSON.stringify(data));
};

export const getUserData = (): UserInformationType => {
  return JSON.parse(localStorage.getItem("myData") + "") as UserInformationType;
};

export const storeLeaderBoard = (data: RankedUser[]) => {
  return localStorage.setItem("leaderBoard_Data", JSON.stringify(data));
};

export const getLeaderBoard = (): RankedUser[] => {
  return JSON.parse(
    localStorage.getItem("leaderBoard_Data") + ""
  ) as RankedUser[];
};

export const cleanLeaderBoard = (): boolean => {
  localStorage.removeItem("leaderBoard_Data");
  return true;
};

export const getCount = (): UserCount => {
  return JSON.parse(localStorage.getItem("user_count") + "") as UserCount;
};

export const addCount = (data: UserCount): boolean => {
  localStorage.setItem("user_count", JSON.stringify(data));
  return true;
};

export const storeRank = (data: MyRanking) => {
  localStorage.setItem("rankData", JSON.stringify(data));
};

export const getRank = (): MyRanking => {
  return JSON.parse(localStorage.getItem("rankData") + "") as MyRanking;
};

export const storeTotalPoint = (value: String) => {
  localStorage.setItem("points", value + "");
};

export const getTotalPoint = (): { weeklytotal: number; total: number } => {
  return JSON.parse(localStorage.getItem("points") + "") as {
    weeklytotal: number;
    total: number;
  };
};
